import {
  Box,
  List,
  ListItem,
  HStack,
  Text,
  VStack,
  CircularProgress,
  Button as CButton,
  useDisclosure,
} from "@chakra-ui/react";
import Button from "components/Button/Button";
import TransactionDetailModal from "components/Modals/cards/TransactionDetail";

import { useMemo } from "react";
import { useHistory } from "react-router-dom";

import { CgDatabase } from "react-icons/cg";

import formatter from "util/formatter";
import { toQueryString } from "util/utils";

import { useGetUserCardTransactionsQuery } from "services/cardsApi";
import { format, parseISO } from "date-fns";

export const TransactionItem = ({
  type,
  currency,
  description,
  createdAt,
  value,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const getColor = (type) => {
    const map = {
      credit: "#00BA88",
      debit: "#ED2E7E",
    };

    return map[type ?? "credit"];
  };

  return (
    <>
      <ListItem
        w="100%"
        as={CButton}
        minH="fit-content"
        bg="transparent"
        p="28px 0"
        borderRadius="2px"
        borderBottom={
          //   i !== items.length - 1 ? "1px solid #D9DBE9" : "none"
          "1px solid #D9DBE9"
        }
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        _focus={{ bg: "transparent", shadow: "0 0 0 3px var(--focusColor)" }}
        onClick={onOpen}
      >
        <HStack justifyContent="space-between" w="100%" px="4px">
          <HStack alignItems="flex-start">
            <Box
              mt="6px !important"
              borderRadius="50%"
              boxSize="10px"
              bg={getColor(type)}
            />
            <Box>
              <Text
                textAlign="left"
                fontSize="sm"
                fontWeight="500"
                color="#595B67"
              >
                {description}
              </Text>
              <Text textAlign="left" fontSize="10px">
                {format(parseISO(createdAt), "eee, dd MMM yyyy, HH:mm")}
              </Text>
            </Box>
          </HStack>

          <Text>
            {type === "debit" ? "-" : ""}
            {formatter(currency).format(value?.$numberDecimal)}
          </Text>
        </HStack>
      </ListItem>

      <TransactionDetailModal
        type={type}
        description={description}
        amount={value?.$numberDecimal}
        createdAt={createdAt}
        currency={currency}
        title={`${description} Details`}
        onClose={onClose}
        isOpen={isOpen}
      />
    </>
  );
};

const MyCardTransactions = ({ id }) => {
  const history = useHistory();

  const params = {
    cardId: id,
    limit: 4,
    page: 1,
  };

  // console.log("TRANSACTION QUERIES", toQueryString(params));
  const { data, isLoading } = useGetUserCardTransactionsQuery(
    toQueryString(params)
  );

  const totalTx = useMemo(() => data?.data?.totalCount, [data]);
  const transactions = useMemo(() => data?.data?.transactions, [data]);

  console.log("TRANSACTIONS", transactions);
  // const items = [
  //   {
  //     label: "Card funded",
  //     date: "Tue, 28 Jun 2020, 18:49",
  //     amount: 300000,
  //     type: "credit",
  //   },
  //   {
  //     label: "Withdrawal on",
  //     date: "Tue, 28 Jun 2020, 18:49",
  //     amount: 300000,
  //     type: "debit",
  //   },
  //   {
  //     label: "Card funded",
  //     date: "Tue, 28 Jun 2020, 18:49",
  //     amount: 300000,
  //     type: "credit",
  //   },
  //   {
  //     label: "Card funded",
  //     date: "Tue, 28 Jun 2020, 18:49",
  //     amount: 300000,
  //     type: "credit",
  //   },
  //   {
  //     label: "Card funded",
  //     date: "Tue, 28 Jun 2020, 18:49",
  //     amount: 300000,
  //     type: "credit",
  //   },
  // ];

  return (
    <Box>
      {isLoading && (
        <CircularProgress
          ml="20px !important"
          isIndeterminate
          color="var(--primary)"
          size="20px"
        />
      )}

      {transactions?.length < 1 && !isLoading && (
        <VStack py="32px">
          <Box as={CgDatabase} fontSize="48px" color="grey" />
          <Text color="grey">No Data</Text>
        </VStack>
      )}

      {transactions && (
        <List>
          {transactions.map((tx, i) => (
            // <ListItem
            //   p="20px 0"
            //   borderBottom={
            //     //   i !== items.length - 1 ? "1px solid #D9DBE9" : "none"
            //     "1px solid #D9DBE9"
            //   }
            // >
            //   <HStack justifyContent="space-between">
            //     <HStack alignItems="flex-start">
            //       <Box
            //         mt="6px !important"
            //         borderRadius="50%"
            //         boxSize="10px"
            //         bg={getColor(tx.type)}
            //       />
            //       <Box>
            //         <Text fontSize="sm" fontWeight="500" color="#595B67">
            //           {tx.description}
            //         </Text>
            //         <Text fontSize="10px">
            //           {format(
            //             parseISO(tx.createdAt),
            //             "eee, dd MMM yyyy, HH:mm"
            //           )}
            //         </Text>
            //       </Box>
            //     </HStack>

            //     <Text>
            //       {tx.type === "debit" ? "-" : ""}
            //       {formatter(tx.currency).format(tx.value?.$numberDecimal)}
            //     </Text>
            //   </HStack>
            // </ListItem>
            <TransactionItem key={`transaction-item-${i}`} {...tx} />
          ))}
        </List>
      )}

      {totalTx > params.limit && (
        <HStack justifyContent="flex-end" py="20px">
          <Button
            variant="ghost"
            bg="transparent"
            minW="fit-content"
            color="var(--primary)"
            size="sm"
            onClick={() => history.push(`/dashboard/cards/${id}/transactions`)}
          >
            View more
          </Button>
        </HStack>
      )}
    </Box>
  );
};

export default MyCardTransactions;
